module.exports = __webpack_public_path__ + "img/service_customer_journey.f07bad61.svg";